import { useEffect } from 'react';

import { isObject } from 'lodash';
import { useSelector } from 'react-redux';

import useLocalStorage from 'hooks/useLocalStorage';
import { ensureObject } from 'utils/objects';

export const isAccessibleKeyboardNavEnabled = () =>
  document.querySelector('body')?.classList.contains('acsb-keynav');

const useAccessibility = () => {
  const user = useSelector(state => state.user);
  const { districtSettings, isStudent, isDemoStudent, isCounselor } =
    ensureObject(user);
  const { enableAccessibilityWidget } = ensureObject(districtSettings);
  const [showAccessibilityWidget] = useLocalStorage(
    'showAccessibilityWidget',
    false,
  );

  useEffect(() => {
    let enabled = true;
    // Check if district setting is false
    if (!enableAccessibilityWidget) {
      enabled = false;
      // Check if is other user type than student
    } else if (!isStudent && !isDemoStudent) {
      // Check if isCounselor and has enabled the widget
      enabled = !!(isCounselor && showAccessibilityWidget);
    }

    if (!enabled) {
      return;
    }

    const s = document.createElement('script');
    const h = document.querySelector('head') || document.body;
    s.src = 'https://acsbapp.com/apps/app/dist/js/app.js';
    s.async = true;

    s.onload = () => {
      if (!isObject(window.acsbJS)) {
        return;
      }

      /* cSpell:disable */
      // eslint-disable-next-line no-undef
      acsbJS?.init({
        statementLink: '',
        footerHtml: '',
        hideMobile: false,
        hideTrigger: false,
        disableBgProcess: false,
        language: 'en',
        position: 'right',
        leadColor: '#146FF8',
        triggerColor: '#146FF8',
        triggerRadius: '50%',
        triggerPositionX: 'right',
        triggerPositionY: 'bottom',
        triggerIcon: 'people',
        triggerSize: 'bottom',
        triggerOffsetX: 80,
        triggerOffsetY: 20,
        mobile: {
          triggerSize: 'medium',
          triggerPositionX: 'right',
          triggerPositionY: 'bottom',
          triggerOffsetX: 80,
          triggerOffsetY: 20,
          triggerRadius: '20',
        },
      });
    };
    h.appendChild(s);
  }, [
    enableAccessibilityWidget,
    isCounselor,
    isDemoStudent,
    isStudent,
    showAccessibilityWidget,
  ]);
};

export default useAccessibility;
